var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{staticClass:"circle white--text elevation-2",class:[_vm.statusColor]},[_vm._v(_vm._s(_vm.quantity))])])}
var staticRenderFns = []

export { render, staticRenderFns }